module.exports = __webpack_public_path__ + "static/media/cms-about-icon.0d73894d.svg";